import './FuelCostsSavingsCalculatorSliders.scss';
import CustomSlider from './CustomSlider/CustomSlider';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

export default function Sliders({
  fields,
  averageConsumptionValue,
  dailyCommuteValue,
  onChangeAverageConsumption,
  onChangeDailyCommute,
}) {
  return (
    <div className={'sliders'} data-aos="fade-up">
      <div className={'sliders_slider'}>
        <div className={'sliders_slider_top'}>
          <div className={'sliders_slider_top_title'}>
            <RichText field={fields?.carsAverageConsumption?.fields?.title} />
          </div>
          <div className={'sliders_slider_top_text'}>
            {averageConsumptionValue}
            <span>
              <RichText field={fields?.carsAverageConsumption?.fields?.unit} />
            </span>
          </div>
        </div>
        <div>
          <CustomSlider
            min={fields?.carsAverageConsumption?.fields?.minValue?.value}
            max={fields?.carsAverageConsumption?.fields?.maxValue?.value}
            divisions={7}
            value={averageConsumptionValue}
            step={1}
            onChange={onChangeAverageConsumption}
          />
        </div>
      </div>
      <div className={'sliders_slider'}>
        <div className={'sliders_slider_top'}>
          <div className={'sliders_slider_top_title'}>
            <RichText field={fields?.dailyCommute?.fields?.title} />
          </div>
          <div className={'sliders_slider_top_text'}>
            {dailyCommuteValue}
            <span>
              <RichText field={fields?.dailyCommute?.fields?.unit} />
            </span>
          </div>
        </div>
        <div>
          <CustomSlider
            min={fields?.dailyCommute?.fields?.minValue?.value}
            max={fields?.dailyCommute?.fields?.maxValue?.value}
            divisions={10}
            value={dailyCommuteValue}
            step={5}
            onChange={onChangeDailyCommute}
          />
        </div>
      </div>
    </div>
  );
}
